import { CompanyInfo, Config } from '@websky/core/src/context';
import i18next from 'i18next';
import { getLocale } from '@websky/core/src/utils';
import { Card, CardType } from '@websky/core/src/PromoLoader/types';

export const promoLoaders: Card[] = [
	{
		type: CardType.City,
		title: 'ComfortAndCare.title',
		image: 'https://cdn.websky.aero/content/frontend/images/rt-banners/banner1.jpg'
	},
	{
		type: CardType.City,
		title: 'ReliabilityAndTechnology.title',
		image: 'https://cdn.websky.aero/content/frontend/images/rt-banners/banner2.jpg'
	},
	{
		type: CardType.City,
		title: 'CozyCabin.title',
		image: 'https://cdn.websky.aero/content/frontend/images/rt-banners/banner3.jpg'
	},
	{
		type: CardType.City,
		title: 'FlyFaster.title',
		image: 'https://cdn.websky.aero/content/frontend/images/rt-banners/banner4.jpg'
	}
];

const currentLocale = getLocale() as string;

const BASE_URL = 'https://uvtaero.ru';

const getLocaleLink = (base = BASE_URL): string => {
	if (!currentLocale || currentLocale === 'ru') {
		return base;
	}

	return `${base}/${currentLocale}`;
};

const companyInfo: CompanyInfo = {
	iataCode: 'RT',
	subsidyFaresConditionURL: '',
	loyaltyProgramName: '',
	loyaltyProgramRegistrationUrl: '',
	privacyPolicy: `${getLocaleLink()}/politika_konfidencialnosti`,
	multiInsurance: true,
	specialDocumentForInsurance: false,
	facebook: '',
	instagram: '',
	vk: 'https://vk.com/uvtaero_jsc',
	twitter: '',
	baggage: `${getLocaleLink()}/bagazh`,
	meal: '',
	seat: `${getLocaleLink()}/mesto`,
	legal: `${getLocaleLink()}/pravila-perevozki`,
	webskySearchOrder: `https://booking.uvtaero.ru/websky/#/search-order`,
	insurance: `${getLocaleLink()}/strahovanie`,
	loyaltyProgramAccountUrl: '',
	exarePrivacyPolicyURL: `${getLocaleLink()}/politika_konfidencialnosti`,
	exareRulesURL: `${getLocaleLink()}/o-pokupke-bileta`,
	baggageAnimalsURL: `${getLocaleLink()}/provoz-zhivotnyh`,
	loyalty: {
		links: [
			{ title: 'Status', url: '' },
			{ title: 'Earn miles', url: '' },
			{ title: 'Use miles', url: '' },
			{ title: 'FAQ', url: '' }
		]
	}
};

export const i18n: i18next.Resource = {
	ru: {
		Checkout: {
			Agreement: `Я ознакомлен и согласен c <a data-type="termsOfTariff">условиями тарифа</a>, условиями обработки <a href="${BASE_URL}/politika_konfidencialnosti?s=6" target="_blank">персональных данных</a> и <a href="${BASE_URL}/politika_konfidencialnosti?s=1" target="_blank">политикой конфиденциальности</a>`
		},
		Consents: {
			agreement_rules: `<div>Я ознакомлен и согласен c {{links}}.</div>`,
			agreement_generalRules: `<a href="${BASE_URL}/pravila-perevozki" target="_blank">общими правилами перевозок</a>`,
			agreement_baggageRules: `, правилами <a href="${BASE_URL}/bagazh" target="_blank">провоза багажа</a>`,
			agreement_insurancesRules: ` и <a href="${BASE_URL}/strahovanie" target="_blank">условиями страхования</a>`,
			agreement_interpolation: `{{generalRules}}{{baggageRules}}{{insurancesRules}}`
		},
		AdditionalBaggage: {
			'Buy now and save 20-30%': 'Позаботьтесь о багаже заранее, оформите без комиссий и сборов'
		},
		PromoLoader: {
			'ComfortAndCare.title': 'Комфорт и забота о вас на каждом этапе вашего путешествия',
			'ReliabilityAndTechnology.title': 'Надежность и современные технологии в каждом полете',
			'CozyCabin.title': 'Уютный салон для приятного путешествия',
			'FlyFaster.title': 'Летайте с нами быстрее и дальше'
		}
	},
	en: {
		Checkout: {
			Agreement: `I have read and agree with <a data-type="termsOfTariff">fare conditions</a>, <a href="${getLocaleLink()}/politika_konfidencialnosti?s=6" target="_blank">personal data processing terms</a> and <a href="${getLocaleLink()}/politika_konfidencialnosti?s=1" target="_blank">privacy policy</a>`
		},
		Consents: {
			agreement_rules: `<div>I have read and agree with {{links}}.</div>`,
			agreement_generalRules: `<a href="${getLocaleLink()}/pravila-perevozki" target="_blank">general carriage rules</a>`,
			agreement_baggageRules: `, <a href="${getLocaleLink()}/bagazh" target="_blank">baggage rules</a>`,
			agreement_insurancesRules: ` and <a href="${getLocaleLink()}/strahovanie" target="_blank">insurance terms</a>`,
			agreement_interpolation: `{{generalRules}}{{baggageRules}}{{insurancesRules}}`
		},
		AdditionalBaggage: {
			'Buy now and save 20-30%': 'Take care of your baggage in advance, book without fees and charges'
		},
		PromoLoader: {
			'ComfortAndCare.title': 'Comfort and care for you at every stage of your journey',
			'ReliabilityAndTechnology.title': 'Reliability and modern technology in every flight',
			'CozyCabin.title': 'A cozy cabin for a pleasant travel experience',
			'FlyFaster.title': 'Fly faster and farther with us'
		}
	}
};

export const config: Config = {
	SearchForm: {
		payByMiles: false,
		offerHotels: false,
		showPricesInDatepicker: true,
		enableComplexRoute: true,
		engineURL: './booking',
		selectableCurrencies: [
			{
				code: 'RUB',
				symbol: '₽'
			}
		],
		locationGroups: {
			showAdditionalGroups: true
		}
	},
	Engine: {
		calendarDaysCount: 7,
		promoLoaders: promoLoaders,
		resultsFareSelectorInModal: true,
		checkInURL: `./check-in`,
		accountURL: `./account`
	},
	global: {
		showTaxesInfo: true,
		servicesAvailable: {
			animal: true
		},
		yandexMetrikaId: '32632500',
		fareGroupVariant: 'small',
		companyInfo,
		i18n,
		seatMap: {
			splitByCabin: true,
			showRecommendedSeats: true
		},
		additionalResources: {
			extraSvgs: ['https://cdn.websky.aero/content/RT/images/icons.svg']
		},
		dynamicBaggagePricing: false,
		authMethods: {
			phone: false,
			ffp: false,
			email: true
		}
	},
	FlightStatus: {
		playMarketURL: '',
		appStoreURL: ''
	}
};
